import { render, staticRenderFns } from "./StCareerStage.vue?vue&type=template&id=39b40b7e"
import script from "./StCareerStage.vue?vue&type=script&lang=ts"
export * from "./StCareerStage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports